import { render, staticRenderFns } from "./autocomplete-add-item.component.vue?vue&type=template&id=3221a559&scoped=true&"
import script from "./autocomplete-add-item.component.vue?vue&type=script&lang=ts&"
export * from "./autocomplete-add-item.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3221a559",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
